import { CityLanguage } from '@/context/languages/languageData';
import { CitySpecialty } from '@/data/citySpecialties';

export const getSpecialtySlugForLanguage = (
  specialty: CitySpecialty,
  language: CityLanguage
): string => {
  // First try the requested language
  if (specialty.slugs[language]) {
    return specialty.slugs[language];
  }
  
  // Fallback to English
  return specialty.slugs.en;
};

export const getSpecialtyNameForLanguage = (
  specialty: CitySpecialty,
  language: CityLanguage
): string => {
  // First try the requested language
  if (specialty.names[language]) {
    return specialty.names[language];
  }
  
  // Fallback to English
  return specialty.names.en;
};

export const getSpecialtyDescriptionForLanguage = (
  specialty: CitySpecialty,
  language: CityLanguage
): string => {
  // First try the requested language
  if (specialty.description[language]) {
    return specialty.description[language];
  }
  
  // Fallback to English
  return specialty.description.en;
};

export const getSpecialtyLongDescriptionForLanguage = (
  specialty: CitySpecialty,
  language: CityLanguage
): string => {
  // First try the requested language
  if (specialty.longDescription[language]) {
    return specialty.longDescription[language];
  }
  
  // Fallback to English
  return specialty.longDescription.en;
};
